export default __webpack_public_path__ + "static/bg2-7e59cddc5e90e094638f835c69a78048.png";